// extracted by mini-css-extract-plugin
export default {"text_module":"fsp-text_module","title":"fsp-title","tm_container":"fsp-tm_container","tm_image":"fsp-tm_image"};